import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RecurrentState } from 'types/recurrent';

const initialState: RecurrentState = {
  isLoading: false,
  recurrent: null,
};

const slice = createSlice({
  name: 'recurrent',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
    },

    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    resetError(state) {
      state.error = undefined;
    },

    changeRecurrent(state, action: PayloadAction<boolean>) {
      state.isLoading = false;
      state.recurrent = action.payload;
    },

    getRecurrentSuccess(state, action: PayloadAction<boolean>) {
      state.isLoading = false;
      state.recurrent = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { startLoading, hasError, resetError, changeRecurrent, getRecurrentSuccess } =
  slice.actions;
